export default __webpack_public_path__ + "static/media/Tiger's Chestguard of the Savage Sun.261e77da.jpg";